import { ComponentConfig } from "@measured/puck";
import { Button as _Button } from "@/components/ui/button";
import { toast } from "sonner";

export type ButtonProps = {
  label: string;
  href: string;
  variant: "default" | "outline";
};

export const Button: ComponentConfig<ButtonProps> = {
  label: "Button",
  fields: {
    label: { type: "text" },
    href: { type: "text" },
    variant: {
      type: "radio",
      options: [
        { label: "default", value: "default" },
        { label: "outline", value: "outline" },
      ],
    },
  },
  defaultProps: {
    label: "Button",
    href: "#",
    variant: "default",
  },
  render: ({ href, variant, label, puck }) => {
    return (
      <div>
        <_Button
          onClick={() => {
            if (puck.isEditing) {
              toast.info("You are in edit mode");
              return;
            }
            window.parent.postMessage(
              { type: "openUrl", url: href, target: "_self" },
              "*"
            );
          }}
          variant={variant}
          tabIndex={puck.isEditing ? -1 : undefined}
        >
          {label}
        </_Button>
      </div>
    );
  },
};
